import type { ApiResponse, Pagination, User, UserRole } from "@/types";

import { BaseApi } from "../base.api";
import type { UserContacts, UsersFilter } from "./types";

export * from "./types";

/** Foydalanuvchilar API — backend'dagi `UserManagementController` ning ko'zgusi. */
export class UsersApi extends BaseApi {
  private readonly baseUrl: string = "/users";

  getAll(filter: UsersFilter) {
    return this.request.get<User[], Pagination<User>>(this.baseUrl, { params: filter });
  }

  getById(id: number) {
    return this.request.get<User, ApiResponse<User>>(`${this.baseUrl}/${id}`);
  }

  /** Xabar kanallari va (talaba uchun) ota-ona aloqasi. */
  getContacts(id: number) {
    return this.request.get<UserContacts, ApiResponse<UserContacts>>(
      `${this.baseUrl}/${id}/contacts`,
    );
  }

  changeRole(id: number, role: UserRole) {
    return this.request.patch<User, ApiResponse<User>>(`${this.baseUrl}/${id}/role`, { role });
  }

  block(id: number) {
    return this.request.patch<User, ApiResponse<User>>(`${this.baseUrl}/${id}/block`);
  }

  unblock(id: number) {
    return this.request.patch<User, ApiResponse<User>>(`${this.baseUrl}/${id}/unblock`);
  }
}

export const usersApi = new UsersApi();
